import React from 'react';
import Modal from '@/components/ui/Modal';
import { useModalManager } from '@/components/common/Modal';
import GlossaryTermForm from '@/components/shared/Froala/plugins/GlossaryTerms/AddGlossaryTerm/GlossaryTermForm';
import SubmitFooter from '@/components/ui/Modal/SubmitFooter';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_glossary_term_path } from '@/modules/routes';
import { queryClient } from '@/utils/ReactQuery';
import QueryKeys from '@/utils/QueryKeys';

const EditGlossaryTermModal = ({ glossaryTerm, initialValues = {}, sectionId, onSuccess }) => {
  const { close, isOpen, open } = useModalManager();

  const { isLoading, mutate } = useMutation({
    mutationFn: (formData: FormData) => (
      axios
        .patch(plato_api_glossary_term_path(glossaryTerm.id), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(res => console.log(res.data.data))
    ),
    mutationKey: [QueryKeys.GlossaryTerms, QueryKeys.Mutations.Patch, glossaryTerm.id],
    onSettled: async () => {
      await queryClient.invalidateQueries([QueryKeys.GlossaryTerms, sectionId]);
      close();
    },
    onSuccess: () => {
      if (onSuccess) onSuccess();
      close();
    },
  });

  return (
    <>
      <button className="action" type="button" onClick={open}>Edit</button>
      <Modal
        className="tw-h-fit tw-w-[800px]"
        close={close}
        headerText="Create Glossary Term"
        isOpen={isOpen}
      >
        <GlossaryTermForm sectionId={sectionId} initialValues={initialValues} onSubmit={mutate}>
          <SubmitFooter isValid close={close} isLoading={isLoading} />
        </GlossaryTermForm>
      </Modal>
    </>
  );
};

export default EditGlossaryTermModal;
